import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { R as C, T as N, C as x } from "../../../index-D6s0AgMh.js";
import { c as n } from "../../../clsx-OuTLNxxd.js";
import { useState as $ } from "react";
import { I as v } from "../../../icon-BnqXyiyH.js";
import "../icon/iconsList.js";
const y = "_collapsible_1j2wj_29", I = "_arrow_1j2wj_39", l = {
  collapsible: y,
  "collapsible-trigger": "_collapsible-trigger_1j2wj_29",
  "open-top": "_open-top_1j2wj_39",
  arrow: I,
  "open-bottom": "_open-bottom_1j2wj_39",
  "is-highlighted": "_is-highlighted_1j2wj_52",
  "collapsible-label": "_collapsible-label_1j2wj_56",
  "collapsible-container": "_collapsible-container_1j2wj_63",
  "collapsible-content": "_collapsible-content_1j2wj_67",
  "is-full-width": "_is-full-width_1j2wj_74",
  "dialog-overlay-show": "_dialog-overlay-show_1j2wj_1",
  "dialog-content-show": "_dialog-content-show_1j2wj_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1j2wj_1"
}, A = ({
  className: c = "",
  labelOpen: r,
  labelClosed: _,
  children: p,
  onChange: j = () => null,
  isOpen: w = !1,
  openOn: o = "top",
  isHighlighted: g = !1,
  isFullWidth: b = !1,
  ...h
}) => {
  const [s, m] = $(w), d = (t) => {
    m(t), j(t);
  }, a = /* @__PURE__ */ e(x, { className: l["collapsible-content"], children: p }), f = n(l["collapsible-trigger"], l[`open-${o}`]), u = n(
    l["collapsible-container"],
    l[`open-${o}`],
    g && l["is-highlighted"],
    b && l["is-full-width"]
  );
  return /* @__PURE__ */ e(
    C,
    {
      className: `${l.collapsible} ${c}`,
      open: s,
      onOpenChange: d,
      ...h,
      children: /* @__PURE__ */ i("div", { className: u, children: [
        o === "top" && a,
        /* @__PURE__ */ i(N, { className: f, children: [
          /* @__PURE__ */ e(v, { name: "up-arrow", className: l.arrow, size: "small" }),
          /* @__PURE__ */ e("span", { className: l["collapsible-label"], children: s ? _ : r })
        ] }),
        o === "bottom" && a
      ] })
    }
  );
};
export {
  A as Collapsible
};
